import { ActivatedRoute } from '@angular/router';
import { Component } from '@angular/core';
import { WebSiteUsersService } from '../../../services/webSiteUsers/webSiteUsers.service';

@Component({
     
    selector: 'confirmation-account',
    templateUrl: 'confirmation-account.component.html',
    styleUrls: ['confirmation-account.component.scss']
})
export class ConfirmationAccountComponent {
    confirme=false;
    error=false;
    loading=true;
    aleardyConfirmed=false;
    idUser;
    key;
    constructor(public route: ActivatedRoute,private webuser:WebSiteUsersService){
        this.route.params.subscribe(params => {;
            this.key=params['key'];
            this.idUser=params['user'];
            this.webuser.confirme(this.idUser,this.key).subscribe(
                (data:any)=>{
                    this.loading=false;
                    if(data.code==1){
                        this.error=false;
                        this.aleardyConfirmed=false;
                        this.confirme=true;
                    }else{
                        this.error=false;
                        this.aleardyConfirmed=true;
                        this.confirme=false;
                    }
                },
                (err)=>{
                    this.loading=false;
                    this.error=true;
                }
            )
        })
    }
}
